import { Link } from '@gogame/navigation';

export const aiChatbotLink = new Link('ai-chatbot/:id?');
